// Generated from packages/design-tokens/tokens.json. Do not edit by hand.

export const tokens = {
  color: {
    primitive: {
      white: '#FFFFFF',
      gray: {
        50: '#F5F5F7',
        100: '#EFEFF0',
        300: '#D1D1D6',
        400: '#E5E5EA',
        500: '#8E8E93',
        600: '#60606A',
        700: '#48484A',
        800: '#3A3A3C',
        850: '#2C2C2E',
        900: '#1C1C1E',
      } as const,
      blue: {
        500: '#5C7BF0',
        600: '#3B8CDB',
        700: '#5CA5EB',
      } as const,
      teal: {
        500: '#2D9EBE',
        600: '#51BDD9',
      } as const,
      green: {
        500: '#36A67E',
        600: '#4DC89E',
        700: '#4B8A50',
        800: '#66A86B',
      } as const,
      amber: {
        500: '#D67D2F',
        600: '#F29E51',
      } as const,
      coral: {
        500: '#CC6C4A',
        600: '#E88C6D',
      } as const,
      rose: {
        500: '#D94873',
        600: '#F36B8C',
      } as const,
      pink: {
        500: '#CF5AAF',
        600: '#EB7DC9',
      } as const,
      violet: {
        500: '#8D72EB',
      } as const,
      orchid: {
        500: '#BD72EB',
      } as const,
      slate: {
        500: '#758599',
      } as const,
      black: '#000000',
    } as const,
    semantic: {
      light: {
        surface: {
          primary: '#FFFFFF',
          secondary: '#F5F5F7',
          tertiary: '#EFEFF0',
          app: '#FFFFFF',
          panel: '#F8F9FA',
          elevated: '#E5E7EB',
          pressed: '#D1D5DB',
        } as const,
        text: {
          primary: '#1C1C1E',
          secondary: '#60606A',
          tertiary: '#8E8E93',
          muted: '#6B7280',
          disabled: '#9CA3AF',
          onAccent: '#FFFFFF',
        } as const,
        action: {
          primary: '#5C7BF0',
        } as const,
        accent: {
          indigo: '#5C7BF0',
          rose: '#D94873',
          mint: '#36A67E',
          amber: '#D67D2F',
          violet: '#8D72EB',
          teal: '#2D9EBE',
          pink: '#CF5AAF',
          green: '#4B8A50',
          coral: '#CC6C4A',
          slate: '#758599',
          orchid: '#BD72EB',
          sky: '#3B8CDB',
          brand: '#537EFF',
          verified: '#2CA8D4',
        } as const,
        border: {
          primary: '#D1D1D6',
          secondary: '#E5E5EA',
          subtle: '#E5E7EB',
          strong: '#D1D5DB',
        } as const,
        icon: {
          default: '#1C1C1E',
          muted: '#6B7280',
          onAccent: '#FFFFFF',
        } as const,
        presence: {
          online: '#3CCB4F',
        } as const,
        overlay: {
          scrim: 'rgba(0, 0, 0, 0.3)',
        } as const,
        tag: {
          user: 'rgba(0, 0, 0, 0.08)',
        } as const,
      } as const,
      dark: {
        surface: {
          primary: '#1C1C1E',
          secondary: '#2C2C2E',
          tertiary: '#3A3A3C',
          app: '#111318',
          panel: '#15171C',
          elevated: '#222429',
          pressed: '#2F333B',
        } as const,
        text: {
          primary: '#FFFFFF',
          secondary: '#AEAEB2',
          tertiary: '#8E8E93',
          muted: '#6B7280',
          disabled: '#4B515C',
          onAccent: '#FFFFFF',
        } as const,
        action: {
          primary: '#5C7BF0',
        } as const,
        accent: {
          indigo: '#5C7BF0',
          rose: '#F36B8C',
          mint: '#4DC89E',
          amber: '#F29E51',
          violet: '#8D72EB',
          teal: '#51BDD9',
          pink: '#EB7DC9',
          green: '#66A86B',
          coral: '#E88C6D',
          slate: '#758599',
          orchid: '#BD72EB',
          sky: '#5CA5EB',
          brand: '#537EFF',
          verified: '#2CA8D4',
        } as const,
        border: {
          primary: '#48484A',
          secondary: '#3A3A3C',
          subtle: '#222429',
          strong: '#2F333B',
        } as const,
        icon: {
          default: '#F5F6F8',
          muted: '#8C929E',
          onAccent: '#E8EAED',
        } as const,
        presence: {
          online: '#3CCB4F',
        } as const,
        overlay: {
          scrim: 'rgba(0, 0, 0, 0.5)',
        } as const,
        tag: {
          user: 'rgba(255, 255, 255, 0.15)',
        } as const,
      } as const,
    } as const,
  } as const,
  typography: {
    fontFamily: {
      base: 'Lato',
      fallback: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    } as const,
    fontSize: {
      largeTitle: 34,
      title: 22,
      headline: 17,
      body: 17,
      footnote: 13,
      caption: 11,
    } as const,
    fontWeight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    } as const,
    lineHeight: {
      tight: 1.2,
      normal: 1.4,
      relaxed: 1.6,
    } as const,
  } as const,
  spacing: {
    xxs: 2,
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32,
    xxxl: 48,
  } as const,
  radius: {
    xs: 6,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 28,
    pill: 999,
  } as const,
  shadow: {
    sm: {"offsetX":0,"offsetY":2,"blur":4,"spread":0,"color":"rgba(0, 0, 0, 0.1)"},
    md: {"offsetX":0,"offsetY":4,"blur":12,"spread":0,"color":"rgba(0, 0, 0, 0.15)"},
    lg: {"offsetX":0,"offsetY":8,"blur":24,"spread":0,"color":"rgba(0, 0, 0, 0.2)"},
  } as const,
  motion: {
    duration: {
      instant: 0,
      fast: 150,
      standard: 220,
      moderate: 340,
      slow: 500,
    } as const,
    easing: {
      standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      accelerate: 'cubic-bezier(0.4, 0.0, 1, 1)',
      decelerate: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    } as const,
  } as const,
} as const;

export type ColorMode = "light" | "dark";

export type Tokens = typeof tokens;

export type ColorTokens = Tokens["color"];
export type TypographyTokens = Tokens["typography"];
export type SpacingTokens = Tokens["spacing"];
export type RadiusTokens = Tokens["radius"];
export type ShadowTokens = Tokens["shadow"];
export type MotionTokens = Tokens["motion"];
